import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalEditFullyApprovedAlert() {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "productApprovals.ApprovalEditFullyApprovedAlert.title"
    }),
    className: "m-bottom-5",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "productApprovals.ApprovalEditFullyApprovedAlert.content"
    })
  });
}
export default ApprovalEditFullyApprovedAlert;